









import PopupLast from '@/views/templates/tenugui/PopupLast.vue'

export default
  components: {
    PopupLast
  }

  mounted: () ->
    requestAnimationFrame(() =>
      window.addEventListener('scroll', @onScroll)
    )

  destroyed: () ->
    window.removeEventListener('scroll', @onScroll)

  data: () ->
    showPopup: 0

  methods: {
    onScroll: () ->
      wk = document.querySelector('.space04').offsetTop - window.scrollY
      if wk < 0
        return
      if wk - window.innerHeight <= 0
        if @showPopup == 0
          @showPopup = 1
        @$emit('scrollFire')
    close_popup: ()->
      @showPopup = 2
    add_point: (point) ->
      @$emit('addPoint', point)
  }
